import { createDecorator } from 'vue-class-component'

export const NoCache = (): any => {
	return createDecorator((options: any, key: string) => {
		options.computed[key].cache = false;
	});
};